// Check if the current URL's pathname ends with '/collections/custom-item'
document.addEventListener('DOMContentLoaded', function() {
  const currentPath = window.location.pathname; // Get the pathname of the current URL
  const targetSlug = '/collections/custom-item'; // Define the slug to check

  if (currentPath.endsWith(targetSlug)) { // If the path ends with the target slug
    const targetColor = '#9789DA'; // The color to change from
    const newColor = '#536552'; // The color to change to

    // Function to change background and text colors if they match
    function changeColor(element) {
      const computedStyle = window.getComputedStyle(element);

      // Change background color if it matches the target color
      if (computedStyle.backgroundColor === targetColor) {
        element.style.backgroundColor = newColor;
      }

      // Change text color if it matches the target color
      if (computedStyle.color === targetColor) {
        element.style.color = newColor;
      }
    }

    // Recursive function to traverse the DOM and apply color changes
    function traverseAndChange(element) {
      changeColor(element); // Change the color of the current element
      for (const child of element.children) { // Traverse through children
        traverseAndChange(child); // Recursively apply color changes
      }
    }

    // Start traversing from the body element
    traverseAndChange(document.body); // Apply changes throughout the DOM
  }
});

document.addEventListener('DOMContentLoaded', function() {
    var openPopupButton = document.getElementById('openPopup');
    var popup = document.getElementById('popup');
    var closeButton = document.querySelector('.close');

    console.log('openPopupButton:', openPopupButton);
    console.log('popup:', popup);
    console.log('closeButton:', closeButton);

    if (openPopupButton && popup && closeButton) {
        openPopupButton.addEventListener('click', function() {
            console.log('Open button clicked');
            popup.style.display = 'flex';
        });

        closeButton.addEventListener('click', function() {
            console.log('Close button clicked');
            popup.style.display = 'none';
        });

        window.addEventListener('click', function(event) {
            if (event.target == popup) {
                console.log('Outside popup clicked');
                popup.style.display = 'none';
            }
        });
    }
});

